/**
 * Represents a clock-in request for a time entry.
 */
export class TimeEntryClockInRequest {
  /**
   * @param {Object} requestData - The request data object.
   * @param {number} requestData.bookingId - The ID of the booking to clock in for.
   * @param {ClockInForm?} requestData.form
   */
  constructor(requestData) {
    /**
     * The ID of the booking to clock in for.
     * @type {number}
     */
    this.bookingId = requestData.bookingId

    /**
     * @type {ClockInForm}
     */
    this.form = requestData.form ? new ClockInForm(requestData.form) : null
  }
}

export class ClockInForm {
  /**
   * @param {Object} formData
   * @param {RetrospectiveTimeInputModel?} formData.retrospectiveTime
   */
  constructor(formData = {}) {
    /**
     * @type {RetrospectiveTimeInputModel}
     */
    this.retrospectiveTime = new RetrospectiveTimeInputModel(
      formData?.retrospectiveTime
    )
  }
}

export class RetrospectiveTimeInputModel {
  /**
   * @param {Object} params
   * @param {string} params.recordedTime
   */
  constructor(params) {
    /**
     * @type {string}
     * @example 14:30
     */
    this.recordedTime = params.recordedTime
  }
}
